import * as React from "react"
import Container from "@/components/container"
import DetailBackground from "@/components/background/detail-background"
import * as styles from "./index.module.scss"

export const HeaderBar: React.FC<{ title: string }> = ({ title }) => {
  return (
    <DetailBackground>
      <Container className={styles.container}>
        <h1>{title}</h1>
      </Container>
    </DetailBackground>
  )
}
